/**
 * Created by mykurisu on 2018/1/3.
 */
import React from 'react'
import {Link} from 'react-router'
import {Toast} from 'react-weui'
import {TimeStream} from '../../utils'
import axios from 'axios'
import Calendar from './Calendar'
import {WKCurrencyItem} from '../../components/wk'
import '../../css/page/MywkPage.css'
import HistoryNoItem from '../../images/mywk/noitem.png'


class NoItem extends React.Component {
    render() {
        return (
            <div>
                <div className="history_noitem">
                    <img src={HistoryNoItem} alt=""/>
                    <p>当前日期暂无课程<br />前往【发现】浏览更多精彩课程</p>
                    <Link to="/">
                        <div className="to_search">
                            去发现
                        </div>
                    </Link>
                </div>
            </div>
        )
    }
}


class LectureCalendarPage extends React.Component {

    constructor() {
        super();
        this.state = {
            choosing_day: false,
            date_lecture_list: []
        }
    }

    componentDidMount() {
        document.title = '课程日历';
        axios.get(`/api/my/lecture_calendar/lectures/?start_date=${TimeStream(Date.parse(new Date()) / 1000, 'YMD')}&end_date=${TimeStream(Date.parse(new Date()) / 1000 + 86400, 'YMD')}`)
            .then(res => {
                if (res.data) {
                    this.setState({
                        date_lecture_list: res.data.data.lectures,
                        choosing_day: false
                    })
                }
            })
    }

    handleChangeDayData(date) {
        this.setState({
            choosing_day: true
        }, () => {
            axios.get(`/api/my/lecture_calendar/lectures/?start_date=${date}&end_date=${TimeStream(Date.parse(new Date(date)) / 1000 + 86400, 'YMD')}`)
                .then(res => {
                    if (res.data.code === 0) {
                        this.setState({
                            date_lecture_list: res.data.data.lectures,
                            choosing_day: false
                        })
                    }
                })
        })
    }

    handleRemoveList() {
        console.log('remove')

        this.setState({
            date_lecture_list: []
        })
    }

    render() {
        return (
            <div className="mywkpage__calendar">
                <Toast show={this.state.choosing_day} icon="loading">
                    加载中
                </Toast>
                <div className="toparea">
                    <div className="toparea_title">
                        课程日历
                    </div>
                </div>
                <Calendar
                    handleRemoveList = {() => this.handleRemoveList()}
                    handleChangeDayData = {(date) => this.handleChangeDayData(date)}/>
                <div className="calendar__day-content">
                    {this.state.date_lecture_list.length > 0 ?
                        this.state.date_lecture_list.map((item) =>
                            <WKCurrencyItem
                                key={item.id}
                                type="lecture"
                                content={item}
                                attr="mywk_calendar"
                            />)
                    :
                        <div className="day__content-noitem">
                            <NoItem/>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default LectureCalendarPage



// WEBPACK FOOTER //
// ./src/pages/mywkPage/LectureCalendarPage.js